module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Background</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-3 prop-sublabel\">Normal</div>\r\n    <div class=\"col-md-4 nopadding\" >\r\n        <input id=\"styleBGColorTextPicker\" name=\"styleBGColorTextPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleBGColorText ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleBGColorText\" name=\"styleBGColorText\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleBGColorText ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-5 nopadding\" >\r\n        <input id=\"styleBGColor2TextPicker\" name=\"styleBGColor2TextPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleBGColor2Text ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleBGColor2Text\" name=\"styleBGColor2Text\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleBGColor2Text ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-3 prop-sublabel\">Over</div>\r\n    <div class=\"col-md-4 nopadding\" >\r\n        <input id=\"styleBGColorOverTextPicker\" name=\"styleBGColorOverTextPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleBGColorOverText ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleBGColorOverText\" name=\"styleBGColorOverText\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleBGColorOverText ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-5 nopadding\" >\r\n        <input id=\"styleBGColorOver2TextPicker\" name=\"styleBGColorOver2TextPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleBGColorOver2Text ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleBGColorOver2Text\" name=\"styleBGColorOver2Text\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleBGColorOver2Text ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-3 prop-sublabel\">Down</div>\r\n    <div class=\"col-md-4 nopadding\" >\r\n        <input id=\"styleBGColorDownTextPicker\" name=\"styleBGColorDownTextPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleBGColorDownText ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleBGColorDownText\" name=\"styleBGColorDownText\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleBGColorDownText ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-5 nopadding\" >\r\n        <input id=\"styleBGColorDown2TextPicker\" name=\"styleBGColorDown2TextPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleBGColorDown2Text ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleBGColorDown2Text\" name=\"styleBGColorDown2Text\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleBGColorDown2Text ))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}